
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import EstimatesRoutes from '@/router/Estimates';

// SVG
import MainSVG from '@/assets/icon-main.svg';
import TasksSVG from '@/assets/icon-tasks.svg';

// Components
import { VAppHeader, VAppLayout, VAppMain, VAppSidebar, VAppSidebarNavigation } from '@/components/VApp';
import VErrorViewer from '@/components/VErrorViewer.vue';

// Interfaces
import User from '@/ship/Models/User';
import AppSidebarNavigationLink from '@/ship/Models/AppSidebarNavigationLink';

// Utils
import { get } from 'lodash';
import { hasAllPermissions, hasCurrentRoutePermission } from '@/utils/Permissions';

@Component({
    components: {
        VAppHeader,
        VAppLayout,
        VAppMain,
        VAppSidebar,
        VAppSidebarNavigation,
        VErrorViewer,
    },
})
export default class EstimatesMain extends Vue {
    @State user!: User | null;

    public isLoading = false;

    readonly linksList: AppSidebarNavigationLink[] = [
        {
            label: this.$t('projects'),
            to: { name: 'estimates.projects' },
            icon: MainSVG,
            permissions: this.findRoutePermissions('estimates.projects'),
        },
        {
            label: this.$t('page.estimates.journal.title'),
            to: { name: 'estimates.journal' },
            icon: TasksSVG,
            permissions: this.findRoutePermissions('estimates.journal'),
        },
        {
            label: this.$t('page.estimates.listActs.title'),
            to: { name: 'estimates.list-acts' },
            icon: TasksSVG,
            permissions: this.findRoutePermissions('estimates.journal'),
        },
    ];

    get showSidebar() {
        return get(this.$route.meta, 'showSidebar');
    }

    get hasRoutePermission(): boolean {
        return hasCurrentRoutePermission();
    }

    get filteredLinksList(): AppSidebarNavigationLink[] {
        const filteredFirstDepth = this.filterLinksList(this.linksList);
        return filteredFirstDepth.map((link) => ({
            ...link,
            children: link.children && this.filterLinksList(link.children),
        }));
    }

    findRoutePermissions(name: string) {
        return EstimatesRoutes[0].children.find((page) => page.name === name)?.meta.permissions;
    }

    filterLinksList(linksList: AppSidebarNavigationLink[]) {
        return linksList.filter((link) => {
            return link.children || (link.permissions ? hasAllPermissions(link.permissions) : true);
        });
    }

    async created() {
        // redirect to the first available page if the route is estimates
        if (this.$route.name === 'estimates' && this.filteredLinksList.length) {
            this.$router.replace(this.filteredLinksList[0].to);
        }
    }
}
